import { BalanceChangeComponent, TransactedAtComponent } from "@goodfill/domain-properties-components";
import { sortByKeys, SortColumn } from "@goodfill/sort";
import { Table, TableHeader, TableRow } from "@goodfill/ui-components";
import { useMemo, useState } from "react";
import { getTransactionsComparator } from "./DepositHistoryComparator";
import { PresentedDepositHistoryTransaction } from "./PresentedDepositHistoryTransaction";

const header: TableHeader<keyof PresentedDepositHistoryTransaction>[] = [
  { key: "transactedAt", value: "Activity Date" },
  { key: "type", value: "Activity Type" },
  { key: "source", value: "Bank" },
  { key: "amountChange", value: "Amount" },
];

type SortableKeys = keyof PresentedDepositHistoryTransaction;

export const DepositHistoryTable = ({ transactions }: { transactions: PresentedDepositHistoryTransaction[] }) => {
  const [sortColumns, setSortColumns] = useState<readonly SortColumn<SortableKeys>[]>([
    { columnKey: "transactedAt", direction: "DESC" },
  ]);

  // TODO: abstract sortedRows/summaryRows into useSortedRows(rows) and useSummaryRows(rows), respectively
  const sortedRows = useMemo(
    () => sortByKeys(transactions, sortColumns, getTransactionsComparator),
    [transactions, sortColumns],
  );

  const rows: TableRow[] = sortedRows.map((transaction) => {
    return {
      data: [
        <TransactedAtComponent value={transaction.transactedAt} />,
        transaction.type,
        transaction.source ?? "",
        <BalanceChangeComponent value={transaction.amountChange} />,
      ],
    };
  });

  return (
    <Table
      header={header}
      rows={rows}
      onSortChange={(key, i, direction) => {
        setSortColumns([{ columnKey: key, direction: direction }]);
      }}
    />
  );
};
